import { ApplicationElement, html } from '@crossiety/lit-components';
import '@crossiety/lit-components/components/icon/element.js';
import { ifDefined } from 'lit/directives/if-defined.js';

import style from './style.lit.css';

/**
 *  Element that provides the user with an option to navigate to the part of the page it represents.
 *
 *  @prop href - Link
 *  @prop icon - Icon name
 *  @prop badgeCount - Number of the badge counter
 *  @prop active - Indicates active item
 *
 * @slot default - For navigation item name
 *
 * @cssprop --font - Font size
 */

export default class MainNavigationItem extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    href: { type: String },
    icon: { type: String },
    badgeCount: { type: Number },
    active: { type: Boolean },
  };

  connectedCallback() {
    super.connectedCallback();
    this.active = this.activateByCurrentLink();
  }

  render() {
    return html`
      <a href=${this.href} ?active=${this.active}>
        <ef-icon
          name=${this.icon}
          badgeCount=${ifDefined(this.badgeCount)}></ef-icon>
        <slot></slot>
      </a>
    `;
  }
}

customElements.get('xs-main-nav-item') ||
  customElements.define('xs-main-nav-item', MainNavigationItem);
